import DataHelper from "../../helpers/data.helper";
import { formatDateTime } from "../../helpers/dateFormat";
import InitSalaryLogic from "./Salary.logic";

const SalaryComponent: React.FC = () => {
    const { user } = InitSalaryLogic();
    return (
        <div className="page-container">
            <div className="card text-align-center">
                <h1>Moja plata</h1>
                <h3>{user?.firstName} {user?.lastName}</h3>
                <p>{user?.salary} dinara</p>
            </div>

            <h3 className="text-align-center" style={{ marginTop: 20, marginBottom: 12 }}>Moji treninzi</h3>
            {/* Svaki trening u zasebnoj beloj kartici (umesto razdvajanja crtom) */}
            {user?.trainings.map((training: any) => (
                <div key={training.id} className="card">
                    <p style={{ fontWeight: 600, margin: 0 }}>{formatDateTime(training.date)}</p>
                    <p style={{ margin: '4px 0 0', opacity: 0.8 }}>
                        {DataHelper.trainingTypesIdsTrainingTypesForUser[training.trainingType.id] ?? training.trainingType.name ?? ""}
                    </p>
                    {training.clients?.length > 0 && (
                        <div style={{ marginTop: 8 }}>
                            <p style={{ margin: 0, fontSize: '0.85rem', opacity: 0.7 }}>Klijenti:</p>
                            {training.clients.map((client: any) => (
                                <p key={client.id} style={{ margin: '2px 0 0' }}>{client.firstName} {client.lastName}</p>
                            ))}
                        </div>
                    )}
                </div>
            ))}
            {(!user?.trainings || user.trainings.length === 0) && (
                <p style={{ textAlign: "center", opacity: 0.6, marginTop: 16 }}>Nema treninga u periodu.</p>
            )}
        </div>
    );
}

export default SalaryComponent;
